<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <h1 class="text-secondary mb-3">CreateeNewAd</h1>
          <v-form v-model="valid" ref="form" validation class="mb-3">
                  <v-text-field
                    label="Ad title"
                    name="title"
                    prepend-icon="mdi-person"
                    type="text"
                    v-model="title"
                    required
                     :rules="[v=>!!v || 'Title is required']"
                  />

                  <v-text-field
                     
                    label="Description"
                    name="description"
                    prepend-icon="mdi-lock"
                    type="text"
                     v-model="description"
                      
                     required
                    :rules="[v=>!!v || 'Description is required']"
                  />
                </v-form>
                <v-layout row class="mb-3">
                  <v-flex xs12>
                    <v-btn @click="triggerUpload" class="warning">
                      Upload
                      <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                     ref="fileInput"
                     type="file"
                     style="display:none;"
                     accept="image/*"
                     @change="onFileChange"
                      

                        >

                    
                  </v-flex>
                </v-layout>
                 <v-layout row>
                  <v-flex xs12>
                     <img :src="imageSrc" height="100" v-if="imageSrc">
                  </v-flex>
                </v-layout> 
                <v-layout row>
                  <v-flex xs 12>
                    <img src="">
                  </v-flex>
                  </v-layout>
                  <v-layout row>
                  <v-flex xs12>

                       <v-switch
                          v-model="promo"
                          label="Add to promo?"
                          color="indigo"
                        ></v-switch>
                  </v-flex>
                </v-layout>
                 <v-layout row>
                  <v-flex xs12>
                      <v-spacer> </v-spacer> 
                      <v-btn 
                      :loading="loading" 
                      :disabled="!valid || !image || loading"
                      class="success"
                       @click="createAd"
                       > Create ad</v-btn>
                  </v-flex>
                </v-layout>

                 

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  //"loading" чтобы показать статус загрузки
  export default {
    data () {
      return {
        title:'',
        description:'',
        promo: true,
        valid: false,
        image: null,
        imageSrc: ''


      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      }
    },
    methods:{
      createAd(){
        if(this.$refs.form.validate() && this.image){
          //logic
          const ad={
            title: this.title,
            description: this.description,
            promo: this.promo,
            image: this.image
              // imageSrc:  this.image

          }
           this.$store.dispatch('createAd', ad) //после того как сделаем добавление элемента/ в методе then вызовем колбкек
           .then(()=>{
              this.$router.push('/list') //обр к роутеру и перейдем на стр лист после того как созд элемент. и на стр лист сможем увидеть уже этот элемент

           })
           .cath(()=>{})//если произ какая то ошибка катч вызывает пустой колбек. выведем ее визуально и не будем пееходить на новую страницу
        }

      },
      triggerUpload() {
        this.$refs.fileInput.click()
        //передача клика с видимой кнопки на скрытыю
        //т.к. скрытая кнопка нативн эл дом дер то имеет метод клик
      },
      onFileChange(event){
        const file = event.target.files[0]
        const reader = new FileReader()
        reader.onload = e =>{
          this.imageSrc = reader.result
        }
        //FileReader -стандартная библиотека в ДС
        reader.readAsDataURL(file)
        this.image = file
        //передаем данные файла котор подгр в пер файл
        //тк операц асинхр нужно пост просл соб оконч загрузки файла
      }
    }
  }
</script>
